import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../css/labresultaten.scss";
import Header from "../common/Header";
import Footer from "../common/Footer";
import { useTranslation } from "react-i18next";
import { labData } from "../../constans/LabData";

const Labresultaten = () => {
  const { t } = useTranslation();
  const [active, setActive] = useState(0);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const current = labData[active] ?? labData[0];

  return (
    <div>
      <Header />
      <main className="lab-page lab-light-theme">
        <div className="lab__container">
          <header className="lab__hero">
            <nav className="lab__breadcrumb" aria-label={t("lab.breadcrumbAria")}>
              <Link to="/" className="lab__breadcrumb-link">
                {t("lab.breadcrumb", "Home")}
              </Link>
            </nav>
            <h1 className="lab__title">{t("lab.heroTitle", "Lab Results")}</h1>
            <p className="lab__subtitle">{t("lab.heroSubtitle", "Independent third-party testing for guaranteed purity and quality.")}</p>
          </header>

          <div
            className="lab__tabs lab__tabs--top"
            role="tablist"
            aria-label={t("lab.aria.testCategories")}
          >
            {(isMobile ? labData.slice(0, active + 1) : labData).map(
              (tab, i) => (
                <button
                  key={`top-tab-${tab.id}`}
                  role="tab"
                  aria-selected={active === i}
                  className={`lab-tab ${active === i ? "active" : ""}`}
                  onClick={() => setActive(i)}
                >
                  {tab.tabName}
                </button>
              )
            )}
          </div>

          <section className="lab__content" aria-label={t("lab.aria.reports")}>
            <div className="lab__report-wrapper">
              {current.reportImage ? (
                <img
                  className="lab-report-img"
                  alt={`${current.tabName} report`}
                  src={current.reportImage}
                />
              ) : (
                <div className="lab-report-empty">
                  Report image coming soon
                </div>
              )}
            </div>

            <div className="lab__table-wrapper">
              <table className="lab-table-light">
                <tbody>
                  <tr>
                    <td>Test type</td>
                    <td className="highlight-val">Result</td>
                  </tr>
                  <tr>
                    <td>Content (measured)</td>
                    <td className="highlight-val">{current.tableData?.contentMeasured || "-"}</td>
                  </tr>
                  <tr>
                    <td>Purity (HPLC)</td>
                    <td className="highlight-val">{current.tableData?.purity || "-"}</td>
                  </tr>
                  <tr>
                    <td>Laboratory</td>
                    <td className="highlight-val">{current.tableData?.laboratory || "-"}</td>
                  </tr>
                  <tr>
                    <td>Task number</td>
                    <td className="highlight-val">{current.tableData?.taskNumber || "-"}</td>
                  </tr>
                  <tr>
                    <td>Verification code</td>
                    <td className="highlight-val">{current.tableData?.verificationCode || "-"}</td>
                  </tr>
                  <tr>
                    <td>Analysis date</td>
                    <td className="highlight-val">{current.tableData?.analysisDate || "-"}</td>
                  </tr>
                  <tr>
                    <td>Verification</td>
                    <td className="highlight-val">
                      {current.tableData?.verificationLink ? (
                        <a href={current.tableData.verificationLink} target="_blank" rel="noreferrer" className="verify-link">
                          Verify test report
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {current.productLink && (
              <div className="lab__action">
                <Link to={current.productLink} className="lab-btn-view">
                  View Product
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </Link>
              </div>
            )}
          </section>

          {isMobile && (
            <div
              className="lab__tabs lab__tabs--bottom"
              role="tablist"
              aria-label={t("lab.aria.moreTestCategories")}
            >
              {labData.slice(active + 1).map((tab, i) => {
                const realIndex = active + 1 + i;
                return (
                  <button
                    key={`bottom-tab-${tab.id}`}
                    role="tab"
                    aria-selected={active === realIndex}
                    className={`lab-tab ${
                      active === realIndex ? "active" : ""
                    }`}
                    onClick={() => setActive(realIndex)}
                  >
                    {tab.tabName}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Labresultaten;
